"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.worldchainSepolia = void 0;
const defineChain_js_1 = require("../../utils/chain/defineChain.js");
exports.worldchainSepolia = (0, defineChain_js_1.defineChain)({
    id: 4801,
    name: 'World Chain Sepolia',
    network: 'worldchain-sepolia',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://worldchain-sepolia.g.alchemy.com/public'] },
        public: { http: ['https://worldchain-sepolia.g.alchemy.com/public'] },
    },
    blockExplorers: {
        default: {
            name: 'World Chain Sepolia Explorer',
            url: 'https://worldchain-sepolia.explorer.alchemy.com',
        },
    },
    testnet: true,
});
//# sourceMappingURL=worldchainSepolia.js.map